import type { FetchInputType, FetchInitType } from "./types/fetch-params";

// The BigQuery web-event beacon (`window.InnerBalanceClientApi.sendWebEvent`,
// wired up in `ClientApiScript`). This is a SEPARATE telemetry channel from
// Datadog (`useLogEvent`): these events land in BigQuery `ods.prod_web_*`.
// Centralised here so the decision of WHAT reaches the BigQuery error stream
// (`ods.prod_web_errors`) lives in one place — see `useFetchBase`, which only
// calls `sendErrorBeacon` for genuine, unrecovered network failures.

// Fires the per-request beacon (`event_name: "request"`) at the start of every
// API call. No-op for non-string inputs and for the auth bootstrap call (which
// would otherwise recurse through its own event service).
export function sendRequestBeacon(input: FetchInputType, init?: FetchInitType): void {
    if (typeof input !== "string" || input.includes("sendUnauthorizedEvent")) {
        return;
    }

    window.InnerBalanceClientApi?.sendWebEvent({
        event_name: "request",
        event_type: "user_non_interaction",
        widget: "api",
        meta_data: {
            request_id: Date.now().toString(),
            endpoint: input,
            http_method: init?.method || "GET",
            request_ts: new Date().toISOString(),
        },
    });
}

// Fires the error beacon (`event_name: "error"`) — the one that feeds BigQuery
// `ods.prod_web_errors`. Call ONLY for real errors; benign client-side
// cancellations must NOT reach this channel (see `logFetchCancellation`).
export function sendErrorBeacon(input: FetchInputType, message: string): void {
    // Symmetric with `sendRequestBeacon`: only string inputs produce
    // meaningful telemetry. A URL/Request object would serialize
    // unpredictably (a `Request` → `{}`), so skip it — and stay consistent
    // with the request beacon, which never fired for non-string inputs either.
    if (typeof input !== "string") {
        return;
    }

    window.InnerBalanceClientApi?.sendWebEvent({
        event_name: "error",
        event_type: "user_non_interaction",
        widget: "api",
        meta_data: {
            url: input,
            error_text: message,
            error_msg_response: message,
        },
    });
}
